import React, { useState, useEffect } from "react";

import {
  Row,
  Col,
  Image,
  Button,
  Modal,
  Container,
  Form,
  ButtonGroup,
} from "react-bootstrap";

import { Map, Marker, GoogleApiWrapper } from "google-maps-react";

import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";

let searchOptions = {
  componentRestrictions: { country: ["in"] },
};

const MapLocation = ({ clickHandler, ...props }) => {
  const [value, setValue] = useState({
    weekDays: [],
    startPoint: [],
    endPoint: [],
    dayOrdate: "",
    weekNoDay: [],
    freq: "",
    address: "",
    addressSec: "",
    weight: "",
  });
  const [mapCenter, setMapCenter] = useState({
    lat: 9.931233,
    lng: 76.267303,
  });
  const [mapCenterChange, setMapCenterChange] = useState({
    lat: 9.957396,
    lng: 76.342911,
  });


useEffect(() => {
   
    if (props.item && props.item.addr) {
      setValue({
        ...value,
        address: props.item.addr,
        startPoint: [props.item.geo[0], props.item.geo[1]],
      });
      setMapCenter({ lat: props.item.geo[0], lng: props.item.geo[1] });
      setMapCenterChange({ lat: props.item.geo[0], lng: props.item.geo[1] });
    }
  }, []);

  const moveMarker = async (coord, map, t) => {
    const { latLng } = coord;
    const lat = latLng.lat();
    const lng = latLng.lng();

    let coordinates = {
      lat,
      lng,
    };

    switch (t.name) {
      case "startPoint":
        setValue({
          ...value,
          startPoint: [lat, lng],
          address: await getAddress(lat, lng),
        });
        setMapCenter(coordinates);
        setMapCenterChange(coordinates);

        break;

      default:
    }
  };

  const getAddress = (lat, lng) => {
    let GKEY = "AIzaSyCxF1uLyza5mw9xvMNMzgTDj_KL8Tt8XEA";
    return fetch(
      "https://maps.googleapis.com/maps/api/geocode/json?address=" +
        lat +
        "," +
        lng +
        "&key=" +
        GKEY
    )
      .then((response) => response.json())
      .then((responseJson) => {
        let address = responseJson.results[0].formatted_address;
        return address;
      });
  };

  const handleChange = (address) => {
    setValue({
      ...value,
      address: address,
    });
  };

  const handleSelect = (address) => {
    setValue({
      ...value,
      address: address,
    });

    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        setValue({
          ...value,
          address: address,
          startPoint: [latLng.lat, latLng.lng],
        });
        setMapCenter(latLng);
        setMapCenterChange(latLng);
      })
      .catch((error) => console.error("Error", error));
  };

  const addStore = () => {
    // clickHandler(3, { addr1: value.address, geo: value.startPoint });
  };
  const submit = () => {
  
    props.setlocationHandler({ addr: value.address, geo: value.startPoint });
  };
  return (
    <div className="modeldivcontent">
      <div>
        <div className="userModalDiv">
          <Modal
            show={props.showViewModal}
            onHide={props.closeViewModal}
            animation={false}
            size="lg"
            className="detail-modal-align"
            backdrop="static"
            centered
            style={{ backgroundColor: "rgba(0, 0, 0, 0.24)" }}
          >
            <Modal.Header className="mastr-mdl-hd" closeButton>
              <Modal.Title></Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col lg={12} md={12} sm={12} xs={12}>
                  <Container>
                    <div>
                      <Form.Group
                        controlId="startPoint"
                        style={{ width: "100%" }}
                      >
                        <Form.Label className="mandatoryField">
                          Location
                        </Form.Label>
                        <div>
                          <PlacesAutocomplete
                            value={value.address}
                            onChange={handleChange}
                            onSelect={handleSelect}
                            className="form-control"
                            searchOptions={searchOptions}
                            name="startPoint"
                            shouldFetchSuggestions={value.address.length > 2}
                          >
                            {({
                              getInputProps,
                              suggestions,
                              getSuggestionItemProps,
                              loading,
                            }) => (
                              <div>
                                <input
                                  {...getInputProps({
                                    placeholder: "Search Places ...",
                                    className:
                                      "form-control location-search-input",
                                      autoFocus:true
                                  })}
                                />
                                <div className="autocomplete-dropdown-container">
                                  {loading && <div>Loading...</div>}
                                  {suggestions.map((suggestion) => {
                                    const className = suggestion.active
                                      ? "suggestion-item--active"
                                      : "suggestion-item";

                                    const style = suggestion.active
                                      ? {
                                          backgroundColor: "#fafafa",
                                          cursor: "pointer",
                                        }
                                      : {
                                          backgroundColor: "#ffffff",
                                          cursor: "pointer",
                                        };
                                    return (
                                      <div
                                        {...getSuggestionItemProps(suggestion, {
                                          className,
                                          style,
                                        })}
                                      >
                                        <span>{suggestion.description}</span>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                          </PlacesAutocomplete>
                        </div>
                      </Form.Group>
                    </div>
                  </Container>
                </Col>
              </Row>
              <Row>
                <Col lg={12} md={12} sm={12} xs={12}>
                  <Container>
                    <div className="mapDiv">
                      <Map
                        google={props.google}
                        initialCenter={{
                          lat: mapCenter.lat,
                          lng: mapCenter.lng,
                        }}
                        center={{
                          lat: mapCenterChange.lat,
                          lng: mapCenterChange.lng,
                        }}
                        zoom={12}
                        label={"Start"}
                      >
                        <Marker
                          title={"Point"}
                          icon={{
                            url: require("../../../assets/img/tracking_map.png"),
                            anchor: new window.google.maps.Point(30, 32),
                            scaledSize: new window.google.maps.Size(80, 80),
                          }}
                          name="startPoint"
                          draggable={true}
                          onDragend={(t, map, coord) =>
                            moveMarker(coord, map, t)
                          }
                          position={{
                            lat: mapCenter.lat,
                            lng: mapCenter.lng,
                          }}
                        />
                      </Map>
                    </div>
                  </Container>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              {/* <button
              className="btn btn-danger next-btn "
              onClick={() => submit()}
            >
              Next
            </button> */}
              <button
                className="btn btn-danger Modalbutton"
                type="submit"
                onClick={() => submit()}
              >
                SUBMIT
              </button>
            </Modal.Footer>
            {/* <button
              className="btn btn-danger next-btn "
              onClick={() => addStore()}
            >
              Next
            </button>
            <button
              className="btn btn-danger prev-btn"
              type="submit"
              onClick={() => clickHandler(1)}
            >
              Back
            </button> */}
          </Modal>
        </div>
      </div>
    </div>
  );
};
export default GoogleApiWrapper({
  apiKey: "AIzaSyCLgcnr5XYmh5DKmibzX4mu3luTCPkd2GI",
})(MapLocation);
